/* eslint-disable no-extend-native */
// --
// -- Imported once for its side effects, from src/index.tsx.
// --
// -- Deliberately has no import or export: that keeps the file a script rather
// -- than a module, which is what lets `interface String` merge into the global
// -- String type instead of declaring a local one.
// --

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface String {
  capitalizeAll(): string;
  capitalize(): string;
}

String.prototype.capitalize = function () {
  return (this.toString()?.[0] ?? '').toLocaleUpperCase() + (this.toString() ?? '').substring(1);
}

String.prototype.capitalizeAll = function () {
  return (this.toString() || '')
    .split(/\s+/)
    .map(word => word.capitalize())
    .join(' ');
};
